module.exports = __webpack_public_path__ + "img/Dash_report_error.ee9f0ebc.svg";